const dev = {
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://938g7wfqz0.execute-api.us-west-2.amazonaws.com/dev'
  },
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_6fkfObklb',
    APP_CLIENT_ID: '5uvl7g4coecpvsb2j7pp2ghqr',
    IDENTITY_POOL_ID: 'us-west-2:5098d6a9-6b75-4b16-bf90-f1c92cf469a0'
  }
};

const prod = {
/*
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://mce8ubdbo7.execute-api.us-west-2.amazonaws.com/prod'
  },
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_PLOq594Eq',
    APP_CLIENT_ID: '6lotq5q5tmgrlsab44d5g3cn92',
    IDENTITY_POOL_ID: 'us-west-2:e13330fc-aaee-43a4-b13e-f04bbd646543'
  }
*/
};

const config = process.env.REACT_APP_STAGE === 'production'
  ? prod
  : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};



// WEBPACK FOOTER //
// ./src/config.js